export const KINDS = {
  Basic: 'Basic',
  Success: 'Success',
  Info: 'Info',
  Warn: 'Warn',
  Error: 'Error',
} as const

export const SIZES = {
  Large: 'Large',
  Regular: 'Regular',
} as const
